import moment from 'moment'

import styles from './DateTooltip.module.scss'

const DateTooltip = ({ serviceStartDate, actualServiceStartDate, isVisible }) => {
  if (!isVisible) return null

  return (
    <div className={styles.tooltip}>
      {serviceStartDate && (
        <div className={styles.row}>
          <span className={styles.label}>Service Start Date</span>
          <span className={styles.value}>
            {moment(serviceStartDate).format('MMM DD, YYYY')}
          </span>
        </div>
      )}
      {actualServiceStartDate && (
        <div className={styles.row}>
          <span className={styles.label}>Actual Service Start Date</span>
          <span className={styles.value}>
            {moment(actualServiceStartDate).format('MMM DD, YYYY')}
          </span>
        </div>
      )}
      {!serviceStartDate && !actualServiceStartDate && (
        <div className={styles.row}>
          <span className={styles.value}>No dates available</span>
        </div>
      )}
    </div>
  )
}

export default DateTooltip
